import ArrangeStatistics from './src/main';

/* istanbul ignore next */
ArrangeStatistics.install = function(Vue) {
  Vue.component(ArrangeStatistics.name, ArrangeStatistics);
};

export default ArrangeStatistics;
